import * as React from 'react';
const Sticky = ({ children, stickyClassName }) => {
    const containerRef = React.useRef(), noStickyContainerRef = React.useRef(), isFixed = React.useRef(), containerTop = React.useRef();
    const onScroll = () => {
        if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
            if (!containerTop.current) {
                containerTop.current = containerRef.current.offsetTop;
            }
            if (noStickyContainerRef.current) {
                const styles = window.getComputedStyle(containerRef.current), calculatedHeight = containerRef.current.offsetHeight +
                    parseInt(styles.paddingBottom) +
                    parseInt(styles.paddingTop) +
                    parseInt(styles.marginBottom) +
                    parseInt(styles.marginTop);
                noStickyContainerRef.current.style.height = `${calculatedHeight}px`;
            }
            const scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
            if (!isFixed.current && scrollTop >= containerTop.current) {
                containerRef.current.style.position = 'fixed';
                containerRef.current.style.top = '0px';
                if (stickyClassName) {
                    containerRef.current.classList.add(stickyClassName);
                }
                isFixed.current = true;
            }
            else if (isFixed && scrollTop < containerTop.current) {
                containerRef.current.style.position = 'relative';
                if (stickyClassName) {
                    containerRef.current.classList.remove(stickyClassName);
                }
                isFixed.current = false;
            }
        }
    };
    React.useEffect(() => {
        window.addEventListener('scroll', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    });
    return (React.createElement("div", { ref: noStickyContainerRef },
        React.createElement("div", { ref: containerRef }, children)));
};
export default Sticky;
